// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.section-large__title[data-v-99001776]{color:var(--text-primary)}@media (min-width:768px){.section-large__title[data-v-99001776]{margin-bottom:4.8rem}}@media (max-width:767px){.section-large__title[data-v-99001776]{margin-bottom:2.4rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
